<template>
  <div>
    <Head :title="__(title)" />
    <div class="flex items-center justify-between mb-6">
      <search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset" />
      <div class="flex gap-2">
        <label class="btn-white cursor-pointer">
          <span>{{ __('Importer CSV') }}</span>
          <input type="file" accept=".csv" class="hidden" @change="importCsv" />
        </label>
        <Link class="btn-indigo" :href="plUrl('create', 'blacklist')">
          <span>{{ __('Bloquer un numéro') }}</span>
        </Link>
      </div>
    </div>

    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <tbody>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">Numéro</th>
            <th class="px-6 pt-6 pb-4">Nom et prénom</th>
            <th class="px-6 pt-6 pb-4">Institution</th>
            <th class="px-6 pt-6 pb-4">Tentatives bloquées</th>
            <th class="px-6 pt-6 pb-4">Dernière tentative</th>
            <th class="px-6 pt-6 pb-4">Expiration</th>
            <th class="px-6 pt-6 pb-4">Statut</th>
            <th class="px-6 pt-6 pb-4"></th>
          </tr>
          <tr v-for="entry in entries" :key="entry.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="px-6 py-4 border-t font-mono text-sm">{{ entry.phone_number }}</td>
            <td class="px-6 py-4 border-t text-sm text-gray-600">{{ entry.label || '—' }}</td>
            <td class="px-6 py-4 border-t text-sm">{{ entry.department || '—' }}</td>
            <td class="px-6 py-4 border-t text-center">
              <span :class="entry.blocked_attempts_count >= 3 ? 'badge-red' : 'badge-gray'">
                {{ entry.blocked_attempts_count }}
              </span>
            </td>
            <td class="px-6 py-4 border-t text-sm text-gray-500">{{ formatRelative(entry.last_attempt_at) }}</td>
            <td class="px-6 py-4 border-t text-sm text-gray-500">{{ entry.expires_at ? formatDate(entry.expires_at) : 'Permanent' }}</td>
            <td class="px-6 py-4 border-t">
              <span :class="entry.is_active ? 'badge-red' : 'badge-gray'">
                {{ entry.is_active ? 'Bloqué' : 'Inactif' }}
              </span>
            </td>
            <td class="px-4 py-4 border-t flex gap-2 justify-end">
              <Link :href="plUrl('edit', entry.id)" class="btn-sm-white">Modifier</Link>
              <button @click="toggle(entry)" class="btn-sm-white">
                {{ entry.is_active ? 'Désactiver' : 'Activer' }}
              </button>
              <button v-if="!entry.deleted_at" @click="destroy(entry)" class="btn-sm-red">Supprimer</button>
              <button v-else @click="restore(entry)" class="btn-sm-white">Restaurer</button>
            </td>
          </tr>
          <tr v-if="entries.length === 0">
            <td class="px-6 py-4 border-t text-gray-500" colspan="8">Aucun numéro en liste noire.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import SearchInput from '@/Shared/SearchInput'
import { Link, Head, router } from '@inertiajs/vue3'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'

const BASE = '/dashboard/settings/phone-lists'

export default {
  layout: Layout,
  components: { SearchInput, Link, Head },
  props: {
    title: String,
    type: String,
    filters: Object,
    entries: Array,
    departments: Array,
  },
  data() {
    return { form: { search: this.filters.search } }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        router.get(BASE + '/blacklist', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    plUrl(action, param) {
      const map = {
        create:  (p) => `${BASE}/create/${p}`,
        edit:    (p) => `${BASE}/${p}/edit`,
        toggle:  (p) => `${BASE}/${p}/toggle`,
        destroy: (p) => `${BASE}/${p}`,
        restore: (p) => `${BASE}/${p}/restore`,
        import:  (p) => `${BASE}/import/${p}`,
      }
      return map[action] ? map[action](param) : BASE
    },
    reset() { this.form = mapValues(this.form, () => null) },
    formatDate(d) { return d ? new Date(d).toLocaleDateString('fr-FR') : '—' },
    formatRelative(d) {
      if (!d) return '—'
      const diff = Date.now() - new Date(d).getTime()
      const h = Math.floor(diff / 3600000)
      if (h < 1) return "il y a moins d'1h"
      if (h < 24) return `il y a ${h}h`
      return `il y a ${Math.floor(h / 24)}j`
    },
    toggle(entry) {
      if (confirm(`${entry.is_active ? 'Désactiver' : 'Activer'} ce blocage ?`)) {
        router.post(this.plUrl('toggle', entry.id))
      }
    },
    destroy(entry) {
      if (confirm('Supprimer ce numéro de la liste noire ?')) {
        router.delete(this.plUrl('destroy', entry.id))
      }
    },
    restore(entry) {
      router.put(this.plUrl('restore', entry.id))
    },
    importCsv(event) {
      const file = event.target.files[0]
      if (!file) return
      const form = new FormData()
      form.append('file', file)
      router.post(this.plUrl('import', 'blacklist'), form)
    },
  },
}
</script>
